
import DOMPurify from 'dompurify';

export interface SanitizeOptions {
  allowImages?: boolean;
  allowLinks?: boolean;
  allowBasicFormatting?: boolean;
}

export const sanitizeHtml = (html: string, options: SanitizeOptions = {}): string => {
  const {
    allowImages = false,
    allowLinks = true,
    allowBasicFormatting = true
  } = options;

  let allowedTags = ['p', 'br'];
  let allowedAttributes: { [key: string]: string[] } = {};

  if (allowBasicFormatting) {
    allowedTags.push(
      'strong', 'em', 'b', 'i', 'u', 'span', 'div',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'ul', 'ol', 'li', 'blockquote', 'pre', 'code',
      'table', 'thead', 'tbody', 'tr', 'td', 'th',
      'details', 'summary', 'hr'
    );
    const styledTags = [
      'span', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'ul', 'ol', 'li', 'blockquote', 'pre', 'code',
      'table', 'thead', 'tbody', 'tr', 'td', 'th',
      'details', 'summary', 'strong'
    ];
    for (const tag of styledTags) {
      allowedAttributes[tag] = ['class', 'style'];
    }
  }

  if (allowLinks) {
    allowedTags.push('a');
    allowedAttributes['a'] = ['href', 'title', 'target', 'rel'];
  }

  if (allowImages) {
    allowedTags.push('img');
    allowedAttributes['img'] = ['src', 'alt', 'title', 'width', 'height', 'class'];
  }

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: allowedTags,
    ALLOWED_ATTR: Object.keys(allowedAttributes).reduce((acc, tag) => {
      return acc.concat(allowedAttributes[tag]);
    }, [] as string[]),
    KEEP_CONTENT: true,
    RETURN_DOM_FRAGMENT: false,
    RETURN_DOM: false
  });
};

export const sanitizeTextContent = (html: string): string => {
  return DOMPurify.sanitize(html, { ALLOWED_TAGS: [], KEEP_CONTENT: true });
};
